import type {ReactElement} from 'react';
import {useElapsedSeconds} from '@Components/ai-chat-window/hooks/useElapsedSeconds';
import type {ElapsedTurnTimeProps} from './elapsed-turn-time.types';
import {formatElapsedTime, SECONDS_BEFORE_SHOWING_ELAPSED_TIME} from './elapsed-turn-time.library';

export function ElapsedTurnTime({turnStartedAt}: ElapsedTurnTimeProps): ReactElement {
  const elapsedSeconds = useElapsedSeconds(turnStartedAt);

  if (elapsedSeconds < SECONDS_BEFORE_SHOWING_ELAPSED_TIME) {
    return <></>;
  }

  return <span className="spacing-m-l-1">{formatElapsedTime(elapsedSeconds)}</span>;
}
